import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './core/guards/auth.guard';
import {FileDownloaderComponent} from './shared/components/file-downloader/file-downloader.component';
import {IsExpertOrMoreGuard} from './core/guards/is-expert-or-more.guard';
import {HomepageComponent} from "./shared/components/homepage/homepage.component";
import {CanAccessAdministrationModuleGuard} from "./core/guards/can-access-administration-module.guard";
import {CanAccessDatavisModuleGuard} from "./core/guards/can-access-datavis-module.guard";

const routes: Routes = [

    {
        path: '',
        pathMatch: 'full',
        component: HomepageComponent,
    },
    {
        path: 'connexion',
        loadChildren:
            () => import('./modules/not-connected/not-connected.module').then(m => m.NotConnectedModule),
    },
    {
        path: 'aides-commissions',
        loadChildren:
            () => import('./modules/aides-configs/aides-configs.module').then(m => m.AidesConfigModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'accueil',
        loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'dossiers',
        loadChildren: () => import('./modules/dossiers/dossiers.module').then(m => m.DossiersModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'page-introuvable',
        loadChildren: () => import('./modules/dossiers/dossiers.module').then(m => m.DossiersModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'commissions',
        loadChildren:
            () => import('./modules/commissions/commissions.module').then(m => m.CommissionsModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'profil',
        loadChildren: () => import('./modules/profil/profil.module').then(m => m.ProfilModule),
    },
    {
        path: 'exports',
        loadChildren: () => import('./modules/exports/exports.module').then(m => m.ExportsModule),
        canActivate: [AuthGuard, IsExpertOrMoreGuard],
    },
    {
        path: 'administration',
        loadChildren:
            () => import('./modules/administration/administration.module').then(m => m.AdministrationModule),
        canActivate: [AuthGuard, CanAccessAdministrationModuleGuard],
    },
    {
        path: 'datavis',
        loadChildren:
            () => import('./modules/datavis/datavis.module').then(m => m.DatavisModule),
        canActivate: [AuthGuard, CanAccessDatavisModuleGuard],
    },
    {
        path: 'telecharger/fichiers/:fileId',
        component: FileDownloaderComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'compare',
        loadChildren: () => import('./modules/compare/compare.module').then(m => m.CompareModule),
        canActivate: [AuthGuard],
    },
    {path: '**', redirectTo: '/page-introuvable/404', pathMatch: 'full'},
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
